/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/training.scss';
import Modal from '../../component/Inc/Modal';
const TeacherTrainingDetail = () => {
  const [modalMemo, setModalMemo] = useState(false);
  const [modalInterview, setModalInterview] = useState(false);
  return (
    <main className="com_container com_training p_teacher_training_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu6_2 ">
            신규 교사 교육 관리
            <span className="bar" />
            <span className="point_txt">상세보기</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <select name="" id="" className="select">
                <option value="2023">2023</option>
              </select>
              <div className="com_calendar_wrap">
                <div className="year">
                  <button className="btn btn_prev"></button>
                  <button className="btn_txt">15기</button>
                  <button className="btn btn_next"></button>
                </div>
                <div className="year">
                  <button className="btn btn_prev"></button>
                  <button className="btn_txt">3회</button>
                  <button className="btn btn_next"></button>
                </div>
              </div>
            </div>

            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="60" />
                  <col width="60" />
                  <col width="60" />
                  <col width="60" />
                  <col width="80" />
                  <col width="80" />
                  <col width="80" />
                  <col width="80" />
                  <col width="80" />
                  <col width="180" />
                  <col width="80" />
                  <col width="60" />
                  <col width="60" />
                  <col width="60" />
                  <col width="60" />
                  <col width="60" />
                  <col width="80" />
                  <col width="80" />
                  <col width="80" />
                  <col width="80" />
                </colgroup>
                <thead>
                  <tr>
                    <th rowSpan="2">No.</th>
                    <th rowSpan="2">선택</th>
                    <th rowSpan="2">지점</th>
                    <th rowSpan="2">과목</th>
                    <th rowSpan="2">이름</th>
                    <th rowSpan="2">나이/성별</th>
                    <th rowSpan="2">연락처</th>
                    <th rowSpan="2">유입</th>
                    <th rowSpan="2">지역</th>
                    <th rowSpan="2">메모</th>
                    <th rowSpan="2">교육 이력</th>
                    <th rowSpan="2">면접등급</th>
                    <th colSpan="2">과제평가</th>
                    <th colSpan="5">출석부</th>
                    <th rowSpan="2"> 상태</th>
                  </tr>
                  <tr>
                    <th>1회</th>
                    <th>2회</th>
                    <th>1회</th>
                    <th>2회</th>
                    <th>3회</th>
                    <th>화상교육</th>
                    <th>배정자면답</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>
                      <input type="checkbox" id="chk00" className="com_chk" />
                      <label htmlFor="chk00"></label>
                    </td>
                    <td>겸업</td>
                    <td>수학</td>
                    <td>홍길동103</td>
                    <td>29/남</td>
                    <td>010-1234</td>
                    <td>신규</td>
                    <td>시군구</td>
                    <td>
                      <button onClick={() => setModalMemo(true)}>태도가 좋음…</button>
                    </td>
                    <td>1차</td>
                    <td>
                      <span className="btn_link blue">A</span>
                    </td>
                    <td>37</td>
                    <td>D</td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <select className="select">
                        <option value="/">/</option>
                      </select>
                    </td>
                    <td>
                      <select className="select">
                        <option value="/">/</option>
                      </select>
                    </td>
                    <td>
                      <button onClick={() => setModalInterview(true)} className="circle" />
                    </td>
                    <td>
                      <select name="" id="">
                        <option value="수료">수료</option>
                        <option value="진행">진행</option>
                      </select>
                    </td>
                  </tr>
                  {[...Array(5)].map((i, idx) => (
                    <tr key={idx}>
                      <td>1</td>
                      <td>
                        <input type="checkbox" id="chk00" className="com_chk" />
                        <label htmlFor="chk00"></label>
                      </td>
                      <td>겸업</td>
                      <td>수학</td>
                      <td>홍길동103</td>
                      <td>29/남</td>
                      <td>010-1234</td>
                      <td>신규</td>
                      <td>시군구</td>
                      <td>
                        <button onClick={() => setModalMemo(true)}>태도가 좋음…</button>
                      </td>
                      <td>1차</td>
                      <td>
                        <span className="btn_link blue">A</span>
                      </td>
                      <td>37</td>
                      <td>D</td>
                      <td>미배정</td>
                      <td>
                        <button className="circle" />
                      </td>
                      <td>
                        <select className="select">
                          <option value="X">X</option>
                        </select>
                      </td>
                      <td>
                        <select className="select">
                          <option value="/">/</option>
                        </select>
                      </td>
                      <td>
                        <button onClick={() => setModalInterview(true)} className="circle" />
                      </td>
                      <td>입사포기</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </section>
        <div className="com_btn_wrap">
          <button className="com_btn gray s">선택 인원 삭제</button>
        </div>
        <section className="com_pg_container">
          <section className="box full">
            <div className="info_box">
              <div className="info_row">
                <div className="info_label">계약자</div>
                <div className="info_value">206명</div>
              </div>
              <div className="info_row">
                <div className="info_label">유지자</div>
                <div className="info_value">166명</div>
                <div className="info_label indent">수업진행률</div>
                <div className="info_value">43.70%</div>
              </div>
              <div className="info_row">
                <div className="info_label">평균 10타임 이상 손실률</div>
                <div className="info_value">75% 이상</div>
              </div>
              <div className="info_row">
                <div className="info_label">우수 신규교사 </div>
                <div className="info_value">22명 (14.56%)</div>
              </div>
              <div className="info_row">
                <div className="info_value">
                  <div className="txt label">국어(2) :</div>
                  <div className="txt value">문상연, 최선지</div>
                  <div className="txt label">수학(3) :</div>
                  <div className="txt value"> 조윤희, 명형환, 염우진</div>
                  <div className="txt label">영어(5) :</div>
                  <div className="txt value">김경민, 윤수정, 전정호, 표성협, 우민호</div>
                  <div className="txt label">사탐(2) :</div>
                  <div className="txt value">박찬, 전성식</div>
                  <div className="txt label">과탐(4) :</div>
                  <div className="txt value">고지연, 손세용, 장지영, 정윤제</div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <div className="com_btn_wrap center">
          <button className="com_btn orange s">저장</button>
        </div>
      </div>
      <Modal open={modalMemo} close={() => setModalMemo(false)} type="type_alert">
        <h2 className="pop_tit">메모</h2>
        <div className="content_container">
          <textarea name="" id="" className="textarea"></textarea>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs" onClick={() => setModalMemo(false)}>
            확인
          </button>
        </div>
      </Modal>
      <Modal open={modalInterview} close={() => setModalInterview(false)} type="type_alert">
        <h2 className="pop_tit">배정자 면담</h2>
        <div className="content_container">
          <textarea name="" id="" className="textarea"></textarea>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs" onClick={() => setModalInterview(false)}>
            확인
          </button>
        </div>
      </Modal>
    </main>
  );
};

export default TeacherTrainingDetail;
